import axios from "axios";

export const fetchComType = async () => {
  try {
    const response = await axios.get("http://localhost:8080/webnet-hms/api/company-type/all");
    const rawData = response.data.data;
    const flatData = rawData.flat();
    return flatData;
  } catch (error) {
    console.error("Error fetching notifications:", error);
    return [];
  }
};
export const fetchComType1 = async (id) => {
  try {
    const response = await axios.get(`http://localhost:8080/webnet-hms/api/company-type/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching notifications:", error);
    return [];
  }
};
